import React from 'react';
import "./Breadcrumb.scss";
import PropTypes from 'prop-types';

const Breadcrumb = ({ items, label }) => {
  return (
    <>
      <div className="breadcrumb-position">
        <a className="a-tag" href="/">Security Portal</a> 
        <div>{'>'}</div>
        {items.length > 0 && (
          <>
            <a className="a-tag" href={items[0].path}>{items[0].label}</a>
            <div>{'>'}</div>
          </>
        )}
        <div>{label}</div>
      </div>
    </>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string,
    })
  ),
  label: PropTypes.string.isRequired,
};

export default Breadcrumb;
